import { useMutation } from '@tanstack/react-query';
import { graphql } from '../gql/gql';
import { useAuth0 } from '../auth/AuthProvider';
import type { PaymentIntentCreateInput } from '../gql/graphql';
import { graphqlRequest } from '../utils/graphqlClient';
import { CreatePaymentIntentMutation } from '../gql/graphql';

const createPaymentIntentMutation = graphql(`
  mutation createPaymentIntent($input: PaymentIntentCreateInput!) {
    createPaymentIntent(input: $input) {
      clientSecret
      totalAmount
      discountApplied
    }
  }
`);

const useCreatePaymentIntent = () => {
  const { getAccessTokenSilently, isAuthenticated } = useAuth0();

  return useMutation<
    CreatePaymentIntentMutation,
    Error,
    PaymentIntentCreateInput
  >({
    mutationFn: async (input: PaymentIntentCreateInput) => {
      return graphqlRequest<CreatePaymentIntentMutation>(
        createPaymentIntentMutation,
        { input },
        isAuthenticated ? getAccessTokenSilently : undefined,
      );
    },
  });
};

export default useCreatePaymentIntent;
